import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useJobApplicants } from './job-applicants-provider';

function JobApplicantsStatisticView() {
   const { t } = useTranslation('global');
   const jobApplicants = useJobApplicants();
   return (
      <div className="JobseekerProfileSearch">
         <div className="Calcultn">
            <h4>{jobApplicants.jobInfo?.search_count}</h4>
            <h6>
               <span>
                  <i className="fa fa-search icon_calcultn" />{' '}
               </span>
               {t('employerInnerAccountdetail.searchViews')}
            </h6>
         </div>
         <div className="Calcultn">
            <h4>{jobApplicants.jobInfo?.view_count}</h4>
            <h6>
               <span>
                  <i className="fa fa-suitcase icon_calcultn" />{' '}
               </span>
               {t('employerInnerAccountdetail.jobViews')}
            </h6>
         </div>
         <div className="Calcultn">
            <h4>{jobApplicants.jobSeekers?.totalCandidate}</h4>
            <h6>
               <span>
                  <i className="fa-solid fa-clipboard-check" />{' '}
               </span>
               {t('employerInnerAccountdetail.applied')}
            </h6>
         </div>
      </div>
   );
}

export const JobApplicantsStatistic = observer(JobApplicantsStatisticView);
